/**
 * Product Template - Core Functionality
 * Handles essential product page features: variants, gallery, add to cart
 */

// Import existing product functionality
import { VariantManager } from '../../product/VariantManager.js'

// Import gallery functionality
import { ProductGallery } from '../gallery.js'

// Import components
import '../../components/CollapsibleDropdown.js'

// Optional: Import VideoSection directly if product page needs video functionality
// import VideoSection from '../../components/VideoSection.js'

function redBadgeLabelFromVariant(variant, fallback) {
  const fb = fallback != null && fallback !== '' ? String(fallback) : ''
  if (!variant) return fb
  const price = Number(variant.price)
  const compare = Number(variant.compareAtPrice || variant.compare_at_price || 0)
  if (!compare || compare <= price || !Number.isFinite(price)) return fb
  const pct = Math.round((compare - price) * 100 / compare)
  if (pct <= 0) return fb
  return `${pct}% OFF`
}

function initPdpRedBadge() {
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant
    document.querySelectorAll('[data-pdp-red-badge]').forEach((el) => {
      const fallback = el.dataset.redBadgeFallback || ''
      const label = redBadgeLabelFromVariant(variant, fallback)
      el.textContent = label
      el.classList.toggle('hidden', !label)
    })
  })
}

function initProductPage() {
  console.log('📦 [Product Template] Initializing core functionality...')
  
  // Initialize product gallery FIRST so it can listen for variant events
  initProductGallery()
  
  // Initialize variant management AFTER gallery is ready to listen
  initVariantManager()
  
  // Add to cart functionality is now handled centrally by the cart manager
  
  // Initialize collapsible dropdowns
  initCollapsibleDropdowns()

  initWhatsInTheBox()

  initPdpRedBadge()
  
  console.log('✅ [Product Template] Core initialization complete')
}

function initVariantManager() {
  const productForms = document.querySelectorAll('[data-product-form]')
  
  if (productForms.length > 0) {
    console.log('🔄 [Product Template] Variant manager found, initializing...')
    
    // Initialize variant manager with proper options
    const variantManager = new VariantManager({
      variantSelector: '[data-variant-select]',
      variantInput: '[data-variant-id]',
      priceSelector: '[data-product-price]',
      comparePriceSelector: '[data-compare-at-price]:not(.variant-swatch)',
      addToCartButton: '[data-submit-button]',
      buttonTextSelector: '[data-button-text]',
      swatchSelector: '.variant-swatch',
      urlParameter: 'variant'
    })
    
    console.log('✅ [Product Template] Variant manager initialized successfully')
  } else {
    console.log('⚠️ [Product Template] No product forms found')
  }
}

function initProductGallery() {
  // Check for gallery elements using the correct selectors
  const mainGallery = document.querySelector('[data-main-gallery]')
  
  if (mainGallery) {
    console.log('🖼️ [Product Template] Product gallery found, initializing...')
    
    // Initialize the ProductGallery class
    const gallery = new ProductGallery()
    
    console.log('✅ [Product Template] Product gallery initialized successfully')
  } else {
    console.log('⚠️ [Product Template] No product gallery found (no [data-main-gallery] element)')
  }
}


function initCollapsibleDropdowns() {
  const collapsibleDropdowns = document.querySelectorAll('[data-dropdown]')
  
  if (collapsibleDropdowns.length > 0) {
    console.log('🔽 [Product Template] Collapsible dropdowns found, initializing...', collapsibleDropdowns.length)
    
    collapsibleDropdowns.forEach(dropdown => {
      console.log('🔽 [Product Template] Processing dropdown:', dropdown.tagName, dropdown.classList.toString())
      
      // Custom elements initialize automatically when they're created
      // Just log that we found them
      if (dropdown.tagName.toLowerCase() === 'collapsible-dropdown') {
        console.log('✅ [Product Template] Found collapsible-dropdown custom element')
      } else {
        console.log('⚠️ [Product Template] Found non-custom element with data-dropdown, this might need conversion')
      }
    })
  } else {
    console.log('⚠️ [Product Template] No collapsible dropdowns found')
  }
}

const initWhatsInTheBox = () => {
  const whatsInTheBoxImages = document.querySelectorAll('[data-whats-in-the-box-image]');

  window.variant = window.variant || {};

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail.variant;
    const variantId = variant ? variant.id : null;

    console.log('📦 [Product Template] [Whats in the box] Variant changed:', variantId);

    if (!whatsInTheBoxImages.length || !variantId) return;

    const variantData = window.variant[variantId];
    const newImage = variantData ? variantData.whatsInTheBoxImage : null;

    if (newImage) {
      whatsInTheBoxImages.forEach((img) => {
        img.src = newImage;
        img.srcset = newImage;
        img.alt = variant.name || '';
      });
    }
  });
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductPage)
} else {
  initProductPage()
}

export default initProductPage 